(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["circle-collections"] && !Shopify.designMode) return;
  try {
    
/* Inline JS placed above */

  } catch(e) { console.error(e); }
})();
})();
